// extracted by mini-css-extract-plugin
export default {"br":"mm","w80":"nm","card":"om","wrapper":"pm","fullView":"qm","profilePic":"rm","comment":"sm","animate":"tm","shimmer":"um","square":"vm"};
    if(module.hot) {
      // 1714654882118
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  